import { superQiApi } from "./superQi";
import { webApi } from "./web";

// Following is a hack used to detect if the app is running in a super-qi environment.
// This is because 'my' global object is always included, but unfortunately does not
// have any direct way to check if the app is running in super-qi env.
const testIsSuperQi = () => {
  // Ariver: A mobile framework or SDK component used in apps — specifically related to Alibaba's Mini App ecosystem.
  // Griver: Another component or framework used with Ariver, part of the Alibaba mobile tech stack for running mini-apps.
  // AppContainer: Likely a container or shell application framework version that hosts web content or mini apps.
  return ["Ariver", "Griver", "AppContainer"].some((item) => {
    return navigator.userAgent.includes(item);
  });
};

export const currentPlatform = testIsSuperQi() ? "super-qi" : "web";

export const isSuperQi = currentPlatform === "super-qi";
export const isWeb = currentPlatform === "web";

export const platformApi = isSuperQi ? superQiApi : webApi;
